import alwaysNumber from './alwaysNumber';

/**
 * Rounds a given number to the specified decimal precision.
 *
 * @example
 * import roundNumber from '@carvana/futilities/roundNumber';
 * roundNumber(17.33)
 * // () => 17
 * roundNumber(17.33333, 2)
 * // () => 17.33
 */
function roundNumber(value = 0, precision = 0) {
  return Number(
    `${Math.round(
      parseInt(`${alwaysNumber(value) * 100}e${precision}`, 10)
    )}e-${precision}`
  );
}

export default roundNumber;
